import { useBranch } from "@/context/BranchContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { DailyProfitTab } from "@/components/profit/DailyProfitTab";
import { HistoryTab } from "@/components/profit/HistoryTab";
import { WeeklyProfitTab } from "@/components/profit/WeeklyProfitTab";
import { BranchReportTab } from "@/components/profit/BranchReportTab";

const TABS = [
  ["daily", "Daily Entry", DailyProfitTab],
  ["history", "History", HistoryTab],
  ["weekly", "Weekly Summary", WeeklyProfitTab],
  ["branches", "Branch Report", BranchReportTab],
];

export default function Profit() {
  const { activeBranch } = useBranch();
  return (
    <div className="space-y-6" data-testid="profit-page">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-zinc-500">Analytics</div>
        <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight mt-1">Ciboee Profit</h1>
        <p className="text-sm text-zinc-500 mt-1">
          Profit ledger for <span className="font-medium text-emerald-700">{activeBranch?.name || "…"}</span>
          <span className="ml-1">· (Earning for Shop − Price to Shop) − Ciboee 5% − DC Loss − Min Guarantee − Other Expense</span>
        </p>
      </div>
      <Tabs defaultValue="daily" className="space-y-4">
        <TabsList className="bg-zinc-100 flex-wrap h-auto">
          {TABS.map(([v, l]) => (
            <TabsTrigger key={v} value={v} data-testid={`tab-${v}-profit`}>{l}</TabsTrigger>
          ))}
        </TabsList>
        {TABS.map(([v, , C]) => (
          <TabsContent key={v} value={v}><C /></TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
